import React, { useCallback } from 'react'
import { Badge } from '../../Badge'
import formStyles from '../../../styles/forms.module.scss'
import MarkdownEditor from '../../MarkdownEditor/MarkdownEditor'

export interface EditorialMetadata {
  title?: string
  body?: string
}

interface EditorialEditorProps {
  metadata: EditorialMetadata
  onChange: (metadata: EditorialMetadata) => void
}

const EditorialEditor: React.FC<EditorialEditorProps> = ({ metadata, onChange }) => {
  const update = useCallback(
    (patch: Partial<EditorialMetadata>) => onChange({ ...metadata, ...patch }),
    [metadata, onChange],
  )

  const handleBodyChange = useCallback(
    (markdown: string) => update({ body: markdown }),
    [update],
  )

  return (
    <>
      <div className={formStyles.fieldGroup}>
        <label>Title <Badge variant="secondary" size="small">Public</Badge></label>
        <input
          type="text"
          value={metadata.title || ''}
          onChange={(e) => update({ title: e.target.value })}
          placeholder="Optional heading"
        />
      </div>

      <div className={formStyles.fieldGroup}>
        <label>Body <Badge variant="secondary" size="small">Public</Badge></label>
        <MarkdownEditor
          initialValue={metadata.body || ''}
          onChange={handleBodyChange}
          placeholder="Write the editorial body…"
          ariaLabel="Editorial body"
        />
      </div>
    </>
  )
}

export default EditorialEditor
